import type { CustomEffectsEvent } from '@entities/overlay-event'

import { CUSTOM_EFFECTS_TYPE } from '@entities/overlay-event'
import { type EffectPlugin } from '@shared/lib/effect-registry'

import { CustomEffect } from '../CustomEffect'

/**
 * Плагин пользовательских эффектов (custom_effects), совместим с backend-манифестом
 * custom_effects v1.0.0 (payload — part2-report §6). Эксклюзивный рендер обеспечивает
 * isExclusiveEvent (см. entities/overlay-event/model.ts), а не поле плагина —
 * priority живёт на событии, не на EffectPlugin.
 *
 * sound не задаём: у video аудио встроено в дорожку (muted={!hasAudio}),
 * lottie/image — без звука.
 */
export const customEffectsPlugin: EffectPlugin<CustomEffectsEvent> = {
  type: CUSTOM_EFFECTS_TYPE,
  component: CustomEffect,
}
